module.exports = __webpack_public_path__ + "img/offer.49ab274b.svg";